export default "__VITE_ASSET__DzdrrWAd__";